import ServiceDetail from "@/components/ServiceDetail";

const description = [
  "Genspire's Permanent Recruitment service helps organizations identify, attract and hire professionals who are aligned with both the requirements of the role and the long-term objectives of the business. We understand that permanent hiring is not simply about filling an open position; it is about finding the right individual who can contribute to the organization, work effectively within the team and grow with the business.",
  "Our recruitment approach begins with understanding the organization, the role, required skills, experience, responsibilities, reporting structure and expectations. Based on this understanding, we identify relevant talent through focused sourcing and recruitment channels. Candidates are carefully screened against the defined requirements, evaluated for their suitability and presented to you for further consideration.",
  "We also support the recruitment journey through interview coordination, candidate communication and offer-stage assistance. Our focus is on creating a structured and efficient hiring process while maintaining attention to candidate quality and role fit.",
  "Whether you are hiring for a single critical position or managing multiple ongoing recruitment requirements, Genspire provides focused recruitment support designed around the specific needs of your business. By combining a deep understanding of your requirements with a targeted approach to talent identification, we help you build capable teams that support sustainable growth.",
];

const steps = [
  { title: "Understand", text: "We begin with your organization, the role, required skills, experience, responsibilities, and expectations." },
  { title: "Identify", text: "Relevant talent is identified through focused sourcing and recruitment channels matched to the brief." },
  { title: "Evaluate", text: "Candidates are carefully screened against the defined requirements and evaluated for suitability and fit." },
  { title: "Connect", text: "We present strong candidates and support interviews, communication, and the offer stage through closure." },
];

const benefits = [
  "Professionals aligned with both the role and your long-term objectives",
  "A structured, efficient hiring process from brief to closure",
  "Careful screening with attention to candidate quality and role fit",
  "Support through interviews, communication, and the offer stage",
  "Scales from a single critical hire to multiple ongoing requirements",
  "Capable teams built for contribution, culture, and sustainable growth",
];

export default function PermanentRecruitment() {
  return (
    <ServiceDetail
      headlineTop="Permanent"
      headlineAccent="Recruitment."
      tagline="Building teams for long-term success."
      description={description}
      steps={steps}
      benefits={benefits}
      benefitsHeading="Benefits of Permanent Recruitment"
      submitLabel="Discuss Your Requirement"
      pageTestId="permanent-page"
      ctaTitle="Discuss Your Hiring Requirement"
      ctaSub="Tell us about the role — we'll take it from there."
    />
  );
}
